import { useLanguage } from '@providers/LanguageProvider';

export const useLangLink = () => {
  const { lang } = useLanguage();

  const withLang = path => {
    const normalized = path.startsWith('/') ? path : `/${path}`;

    if (lang === 'en') {
      return normalized;
    }

    return `/${lang}${normalized}`;
  };

  return { withLang };
};
